























































































































































































import VueOptions from '@utils/VueOptions'
import EditorContent from '@components/EditorContent'

settings =
  name: 'BrandProvides'
  vue:
    props: ['offer', 'step']

    components: {
      EditorContent,
    }

    data: ->
      openPanel: null

    computed:
      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]

export default VueOptions.vue settings
